import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CoursesSection from './components/CoursesSection';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CoursePage from './pages/CoursePage';
import CourseContentPage from './pages/CourseContentPage';
import AdminPage from './pages/AdminPage';
import { getCurrentUser } from './components/Auth';
import EditCoursePage from './pages/EditCoursePage';
import EditCarouselItemPage from './pages/EditCarouselItemPage';
import MentorPage from './pages/MentorPage';
import TestPage from './pages/TestPage';
import MakeTestPage from './pages/MakeTestPage';
import CertificatePage from './pages/CertificatePage';
import RecordContentPage from './pages/RecordContentPage';

const App = () => {
  const [user, setUser] = useState(getCurrentUser());
  const isAdmin = user && user.userRole === "Admin";
  const isMentor = user && user.userRole === "Mentor";

  return (
    <Router>
      <Navbar user={user} setUser={setUser} />
      <Routes>
        <Route path="/" element={
          <>
            <HeroSection setUser={setUser} />
            <FeaturesSection />
            <CoursesSection />
            <Footer />
          </>
        } />
        <Route path="/home" element={user ? <HomePage /> : <Navigate to="/" />} />
        <Route path="/course/:courseName" element={<CoursePage />} />
        <Route path="/course/:courseName/content" element={user ? <CourseContentPage /> : <Navigate to="/" />} />
        <Route path="/admin" element={isAdmin ? <AdminPage /> : <Navigate to="/home" />} />
        <Route path="/admin/edit-course/:courseId" element={isAdmin ? <EditCoursePage /> : <Navigate to="/home" />} />
        <Route path="/admin/edit-carousel/:itemId" element={isAdmin ? <EditCarouselItemPage /> : <Navigate to="/home" />} />
        <Route path="/admin/record-content/:courseId" element={isAdmin ? <RecordContentPage /> : <Navigate to="/home" />} />
        <Route path="/mentor" element={isMentor ? <MentorPage /> : <Navigate to="/home" />} />
        <Route path="/mentor/edit-course/:courseId" element={isMentor ? <EditCoursePage /> : <Navigate to="/home" />} />
        <Route path="/mentor/record-content/:courseId" element={isMentor ? <RecordContentPage /> : <Navigate to="/home" />} />
        <Route path="/course/:courseName/test" element={<TestPage />} />
        <Route path="/admin/create-test/:courseId" element={<MakeTestPage />} />
        <Route path="/course/:courseName/test/certificate" element={<CertificatePage />} />
        <Route path="/mentor/create-test/:courseId" element={<MakeTestPage />} />
      </Routes>
    </Router>
  );
};

export default App;
